module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup-panel",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('header', {
    staticClass: "popup-header address-popup-header vux-1px-b"
  }, [_c('section', {
    staticClass: "popup-header-title"
  }, [_c('div', {
    staticClass: "popup-btn cancel"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("所在城市")]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn close",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "icon iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('section', {
    staticClass: "popup-header-content"
  }, [(_vm.level > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowProvince ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.provinceName || '请选择'))]) : _vm._e(), _vm._v(" "), (_vm.level > 1 && _vm.provinceId && _vm.cityList.length > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowCity ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityName || '请选择'))]) : _vm._e(), _vm._v(" "), (_vm.level > 2 && _vm.cityId && _vm.districtList.length > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowDistrict ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.districtName || '请选择'))]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "select-panel",
    attrs: {
      "id": "selectPanel"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.provinceAn
    }
  }, [(_vm.isShowProvince) ? _c('ul', {
    key: "province",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.cityId == item.code ? 'actived j-provinceList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onChoseCity(1, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.cityId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.cityAn
    }
  }, [(_vm.isShowCity) ? _c('ul', {
    key: "city",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.cityId == item.code ? 'actived j-cityList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onClickPanel(2, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.cityId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.districtAn
    }
  }, [(_vm.isShowDistrict) ? _c('ul', {
    key: "district",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.districtList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.districtId == item.code ? 'actived j-districtList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onClickPanel(3, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.districtId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d985552"}!./src/components/AddressSelect/main.html
// module id = 53
// module chunks = 7 8 10 13 16 17 20 21 25